const buildings = [
  {
    name: 'Cursor',
    description: 'Autoclicks once every 10 seconds.',
    initialCost: 15,
    productionPerSecond: 0.1,
  }, {
    name: 'Grandma',
    description: 'A nice grandma to bake more cookies.',
    initialCost: 100,
    productionPerSecond: 1,
  }, {
    name: 'Farm',
    description: 'Grows cookie plants from cookie seeds.',
    initialCost: 1100,
    productionPerSecond: 8,
  }, {
    name: 'Mine',
    description: 'Mines out cookie dough and chocolate chips.',
    initialCost: 12000,
    productionPerSecond: 47,
  }, {
    name: 'Factory',
    description: 'Produces large quantities of cookies.',
    initialCost: 130000,
    productionPerSecond: 260,
  },
];

export default buildings;



// WEBPACK FOOTER //
// ./src/settings/buildings.js